import { useQuery } from '@tanstack/react-query'
import { baseClient } from 'builder/modules/apiClient'
import { RecommendAlert, RecommendAlertResponse } from 'builder/modules/jobSearch/types'
import { transformerRecommendAlert } from './utils'

export const useGetRecommendationAlert = () => {
  return useQuery(
    ['useGetRecommendationAlert'],
    async (): Promise<RecommendAlert> => {
      const res = await baseClient.get<RecommendAlertResponse>(
        '/job-alerts/v1/recommendation-subscription',
      )
      return transformerRecommendAlert(res.data)
    },
    {
      staleTime: 3000,
    },
  )
}
